<template>
  <div class="mb-4 divide-y divide-slate-200 rounded-lg bg-white shadow-md dark:divide-slate-600 dark:bg-slate-700">
    <slot name="header"></slot>
    <slot></slot>
    <slot name="footer"></slot>
  </div>
</template>
